export default function ArrowDiamond({ className = '' }: { className?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="67" height="58" fill="none" viewBox="0 0 67 58" className={className}>
      <path fill="#0D7B6D" d="M0 58V19.334L33.5 0 67 19.334V58H0z"></path>
      <path
        fill="#fff"
        d="M35.1 41a1 1 0 01-.7-1.71l4.6-4.58a1 1 0 000-1.42l-4.6-4.58a.997.997 0 01-.219-1.095.999.999 0 01.924-.616 1 1 0 01.705.29l4.59 4.59a3 3 0 010 4.24l-4.59 4.59a1.001 1.001 0 01-.71.29z"
      ></path>
      <path
        fill="#fff"
        d="M28.1 41a1 1 0 01-.7-1.71L32.69 34l-5.29-5.29a1 1 0 111.41-1.42l6 6a1.002 1.002 0 010 1.42l-6 6a1 1 0 01-.71.29z"
      ></path>
    </svg>
  )
}
